import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { store } from './store';
import { CambiarCorreoyContraseñaFormValues, RecuperarUsuario, RecuperarUsuarioFormValues } from '../models/RecuperarUsuario';
import { UserListBusqueda } from '../models/UsersList';

export default class RecuperarUsuarioStore {
    idUsuario: string = ""
    correoUser: string = ""
    existeUsuario: boolean = false
    actualizoPassword: boolean = false
    loading:boolean = false;

    constructor() {
        makeAutoObservable(this)
    }

    RecuperarUsuarioDPI = async (dpi: RecuperarUsuarioFormValues) => {
        this.loading = true
        try {
            const id = await agent.Account.recuperarUsuario(dpi)
            runInAction(() => {
                this.idUsuario = id.Id;
                this.loading = false
                this.existeUsuario = true
                this.correoUser = id.Email
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false
                this.existeUsuario = false
                this.idUsuario = ""
                this.correoUser = ""
            })
        }
    }

    CambiarContraseñaCorreo = async (credenciales: CambiarCorreoyContraseñaFormValues) => {
        this.loading = true
        try{
            const cambiar = await agent.Account.cambiarCorreoyContraseña(credenciales)
            runInAction(() => {
                this.loading = false
                //console.log(cambiar)
            })
        } catch(error){
            runInAction(() => {
                this.loading = false
            })
        }
    }

    ActualizarContraseña = async (credenciales: any) => {
        this.loading = true
        try{
            const actualizar = await agent.Account.actualizarContraseña(credenciales)
            runInAction(() => {
                this.actualizoPassword = true
                this.loading = false
                toast.success(actualizar);
            })
        }catch(error){
            runInAction(() => {
                this.loading = false
                this.actualizoPassword = false
                toast.error(error);
            })
        }
    }

}